import { Content } from "./Content";
import { Root } from "./Root";
import { Title } from "./Title";

export const DashboardCard = Object.assign(Root, { Title, Content });
